import React from "react";
import {
    Card,
    CardHeader,
    CardContent,
    Typography,
    Chip,
    Grid,
    Link
} from "@material-ui/core";

function directionStyle(direction) {
    if (!direction) return {};

    const d = String(direction).toUpperCase();

    if (d === "LONG") {
        return { backgroundColor: "#4caf50", color: "#fff" };
    }

    if (d === "SHORT") {
        return { backgroundColor: "#f44336", color: "#fff" };
    }

    if (d === "HOLD") {
        return { backgroundColor: "#1e3a8a", color: "#fff" };
    }

    return {};
}

function formatPrice(value) {
    if (value == null || value === "") return "–";

    const n = Number(value);
    if (!Number.isFinite(n)) return String(value);

    return n.toLocaleString("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

function parseDateValue(value) {
    if (!value) return null;

    const str = String(value);

    const normalized = str.includes("T")
        ? str
        : str.replace(" ", "T") + "Z";

    const d = new Date(normalized);
    return Number.isNaN(d.getTime()) ? null : d;
}

function formatEventTime(value) {
    const d = parseDateValue(value);
    if (!d) return "–";

    return d.toLocaleTimeString("de-DE", {
        timeZone: "Europe/Berlin",
        hour: "2-digit",
        minute: "2-digit",
    });
}

function formatEventDate(value) {
    const d = parseDateValue(value);
    if (!d) return "";

    return d.toLocaleDateString("de-DE", {
        timeZone: "Europe/Berlin",
    });
}

export default function SignalsListCard({ signals, companyName }) {
    return (
        <Card>
            <CardHeader
                title="Alerts / Signale"
                subheader={companyName || ""}
            />

            <CardContent>
                {signals && signals.length > 0 ? (
                    signals.map((s) => {
                        const displayTime = s.eventTime || s.createdAt || s.eventDate;
                        const displayDate = s.eventDate || s.eventTime || s.createdAt;

                        return (
                            <Grid
                                key={s.id}
                                container
                                spacing={1}
                                alignItems="center"
                                style={{
                                    marginBottom: 12,
                                    paddingBottom: 8,
                                    borderBottom: "1px solid #eee",
                                }}
                            >
                                <Grid item>
                                    <Chip
                                        label={s.symbol || "–"}
                                        size="small"
                                    />
                                </Grid>

                                <Grid item>
                                    <Chip
                                        label={(s.direction || s.action || "–").toUpperCase()}
                                        size="small"
                                        style={directionStyle(s.direction || s.action)}
                                    />
                                </Grid>

                                <Grid item>
                                    <Typography variant="body2">
                                        Preis <b>{formatPrice(s.price)}</b>
                                    </Typography>
                                </Grid>

                                <Grid item>
                                    <Typography variant="body2" color="textSecondary">
                                        Zeit {formatEventTime(displayTime)}
                                    </Typography>
                                </Grid>

                                <Grid item>
                                    <Typography variant="body2" color="textSecondary">
                                        {formatEventDate(displayDate)}
                                    </Typography>
                                </Grid>

                                {(s.companyName || companyName) && (
                                    <Grid item xs={12}>
                                        <Typography variant="body2" color="textSecondary">
                                            {s.companyName || companyName}
                                        </Typography>
                                    </Grid>
                                )}

                                {s.news?.url && (
                                    <Grid item xs={12}>
                                        <Typography variant="body2">
                                            <Link href={s.news.url} target="_blank" rel="noreferrer">
                                                Zur News
                                            </Link>
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        );
                    })
                ) : (
                    <Typography variant="body2">
                        Keine Alerts für diesen Tag gefunden.
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
}